// Module
var code = "<div class=\"smaller-inputs\"> <dropdown-field label=\"Occurrence\" :value.sync=\"occurrence\" :options=\"occurrenceOptions\"></dropdown-field> <div style=\"margin:20px 0\"> <date-range :callbackFunction=\"dateRangeCallback\" :filter.sync=\"filter\" ref=\"picker\" opens=\"left\"></date-range> </div> </div> ";
// Exports
export default code;